import React from 'react';
import { getServerNowMs } from 'shared/queries/serverTime';

/**
 * Returns true once the server-adjusted clock passes `eventTimestampSec`.
 * Sets a single timeout instead of polling every 500ms, so hundreds of
 * GridOdd instances don't each trigger re-renders on the useServerNow tick.
 */
export function useHasEventStarted(
  eventTimestampSec: number | null | undefined
): boolean {
  const startMs =
    eventTimestampSec != null && Number.isFinite(Number(eventTimestampSec))
      ? Number(eventTimestampSec) * 1000
      : null;

  const [started, setStarted] = React.useState(() => {
    if (startMs == null) return false;
    return getServerNowMs() >= startMs;
  });

  React.useEffect(() => {
    if (started || startMs == null) return;

    const remaining = startMs - getServerNowMs();
    if (remaining <= 0) {
      setStarted(true);
      return;
    }

    const timer = setTimeout(() => setStarted(true), remaining + 200);
    return () => clearTimeout(timer);
  }, [startMs, started]);

  return started;
}
